export const InsightType = {
  AccountOptimization: 'AccountOptimization',
  NewOpportunities: 'NewOpportunities',
};
